export const INTERESTING_TAGS = [
  'BUTTON',
  'INPUT',
  'SELECT',
  'TEXTAREA',
  'A',
  'LABEL',
  'IMG',
  'H1',
  'H2',
  'H3',
  'H4',
  'H5',
  'H6',
  'P',
  'SPAN',
  'DIV',
];

export const INTERACTIVE_ROLES = [
  'button',
  'link',
  'textbox',
  'checkbox',
  'radio',
  'menuitem',
  'tab',
  'option',
  'switch',
];

export const INPUT_LIKE_TAGS = [
  'INPUT',
  'TEXTAREA',
  'SELECT',
  'BUTTON',
  'A',
  'IMG',
];
